"use client";
import Image from "next/image"
import { useState } from "react"
import { motion } from 'framer-motion';
import { useTranslations } from "next-intl";
import Link from "next/link";

type TxType = 'internal' | 'external' | 'wallet' | 'all'
const TAB_LABEL: Record<TxType, string> = {
  all: 'All Projects',
  internal: 'Internal',
  external: 'External',
  wallet: 'Wallet',
}

const ExploreProjectsSection = () => {
    const t = useTranslations('ecosystem');
    const l = useTranslations('eco-hover');
    const projects = [
        {
            id: "1",
            logo: "/images/icons/hyra-scan.svg",
            name: "Hyra Scan",
            describe: l('blockchain-scanner-and-monitor-ensuring-system-transparency-and-security'),
            type: "Internal",
            url: "https://scan.hyra.network/"
        },
        {
            id: "2",
            logo: "/images/icons/hyra-ai.svg",
            name: "Hyra AI",
            describe: l('distributed-ai-infrastructure-using-billions-of-edge-devices-for-efficient-cost-effective-ai-services'),
            type: "Internal",
            url: "https://ai.hyra.network/"
        },
        {
            id: "3",
            logo: "/images/icons/hyra-zone.svg",
            name: "Hyra Zone",
            describe: l('train-ai-with-the-power-of-decentralized-gpus'),
            type: "Internal",
            url: "https://hyrazone.com/"
        },

        {
            id: "4",
            logo: "/images/icons/hyra-mega.svg",
            name: "Hyra Mega",
            describe: t('decentralized_marketplace_for_ai_solutions'),
            type: "Internal",
            url: "https://mega.hyra.network/"
        },
        {
            id: "5",
            logo: "/images/icons/hyra-bid.svg",
            name: "Hyra Bid",
            describe: l('online-auction-platform-using-blockchain-for-transparent-auctions'),
            type: "External",
            url: "https://hyrabid.com/"
        },
        {
            id: "6",
            logo: "/images/icons/hyra-one.svg",
            name: "Hyra One",
            describe: l('hyra-one-delivers-a-decentralized-financial-experience-secure-transparent-and-breakthrough'),
            type: "External",
            url: "/coming-soon"
        },

    ] 
    const tabs: TxType[] = ['all', 'internal', 'external']
    const [activeTabs, setActiveTabs] = useState<TxType>('all');
    const [filtered, setFiltered] = useState(projects);

    const handleFilter = (type: TxType) => {
        setActiveTabs(type);
        if (type === 'all') setFiltered(projects);
        else setFiltered(projects.filter(p => p.type.toLowerCase() === type));
    };
    

    return (
        <section className="px-[78px] max-lg:px-10 max-sm:px-4 py-[64px] max-lg:py-[56px] max-w-[1440px] mx-auto min-h-screen max-lg:h-auto">
            <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] max-sm:text-3xl tracking-[-1px] mt-8">{t('explore-all-projects')}</h2>
            <div className="mt-8 flex gap-2">
                {tabs.map((tab, index) => (
                    <button 
                        key={index} 
                        onClick={() => handleFilter(tab as TxType)} 
                        className={`bg-[#F9F9F9] rounded-full py-2 px-4 uppercase text-[13px] border border-transparent leading-none
                            ${activeTabs === tab ? "text-[#06f] border-[#06f]":""}
                        `}
                    >
                        {TAB_LABEL[tab]}
                    </button>
                ))}
            </div>
            <div className="grid grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 gap-6 max-lg:gap-4 mt-[64px]">
                {filtered.map((item, index) => (
                    <motion.div
                        key={item.id}
                        initial={{ opacity: 0, translateY: 40 }}
                        whileInView={{ opacity: 1, translateY: 0 }}
                        transition={{delay:  0.2 * index, duration: 0.8, ease: 'easeOut' }}
                        viewport={{ once: true }}       
                        className="p-6 max-lg:p-4 flex flex-col justify-between border-[2px] border-[#E9F3FF] rounded-[12px]"
                    >
                     {/* <div key={item.id} className="p-6 flex flex-col justify-between border-[2px] border-[#E9F3FF] rounded-[12px]"> */}
                        <div>
                            <div className="flex justify-between">
                                <Image src={item.logo} width={150} height={45} alt="logo"/>
                                <div>
                                    <div className="py-1 px-4 text-base text-[#646464] bg-[#F9F9F9] rounded-full">
                                        {item.type}
                                    </div>
                                </div>
                            </div>
                            <p className="mt-6 text-[22px]/[30px] font-semibold">{item.name}</p>
                            <p className="text-sm text-[#646464] mt-4 line-clamp-3 font-light">
                                {item.describe}
                            </p>
                        </div>
                        <div>
                            {item.url && (
                                <Link target="_blank" href={item.url}>
                                    <button className="mt-8 py-[8px] px-5 border border-[#E9F3FF] rounded-xl flex gap-2 items-center text-base font-medium text-[#06f] hover:border-[#06f]">
                                    {t('explore-now')}
                                    <Image
                                        src={"/images/icons/arrow-up-right.svg"}
                                        width={20}
                                        height={20}
                                        alt="arrow icon"
                                    />
                                    </button>
                                </Link>
                            )}
                        </div>
                     {/* </div> */}
                    </motion.div>
                ))}
            </div>
        </section>
    )
}

export default ExploreProjectsSection